<script setup lang="js">
const props = defineProps({text:String,color:String})
</script>

<template>
<div class="text-3xl md:text-3xl lg:text-[1.8rem] py-4" :class="color">
  {{text}}
</div>
</template>

<style scoped>

</style>
